import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { SalaryGrid } from '../models/SalaryGrid'
import { SalaryGridForm } from '../forms/SalaryGridForm'
import { SalaryGridFilter } from '../filters/SalaryGridFilter'
import { SalaryGridService } from '../services/SalaryGridService'

export const useSalaryGridStore: KsStoreHook<SalaryGrid, SalaryGridForm, SalaryGridFilter> = createKsStore({
  id: 'salaryGrids',
  modelClass: SalaryGrid,
  formClass: SalaryGridForm,
  filterClass: SalaryGridFilter,
  service: SalaryGridService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Grille #${item.id}`,
  signalREventName: 'SalaryGridModel',
  isReferential: true
})
